import { isDefined } from "@clipboard-health/util-ts";
import { useThemeMode } from "@src/appV2/UserPreferences/UserPreferencesProvider";

interface LogoProps {
  url?: string;
  float?: "left" | "right" | "none" | "inline-start" | "inline-end";
  display?: string;
  height?: string | number;
  width?: string | number;
  margin?: string;
  /**
   * Force a specific wordmark variant regardless of the current theme mode.
   * Use on surfaces that don't flip with theme (e.g. a permanently-light
   * login card). Defaults to the theme-aware choice.
   */
  // eslint-disable-next-line react/no-unused-prop-types -- consumed via destructuring in ClipboardLogo; rule doesn't follow the chain to JSX.
  variant?: "brown" | "yellow";
}

function getBasePath(): string {
  if (isDefined(process.env.REACT_APP_BASE_PATH) && process.env.REACT_APP_BASE_PATH !== "") {
    return process.env.REACT_APP_BASE_PATH;
  }

  return "/";
}

export function ClipboardLogo(props: LogoProps) {
  const { url, float, display, height, width, margin, variant } = props;
  const { themeMode } = useThemeMode();
  const basePath = getBasePath();

  const wordmarkVariant = variant ?? (themeMode === "dark" ? "yellow" : "brown");
  const defaultUrl = `${basePath}assets/clipboard-wordmark-${wordmarkVariant}.png`;
  const urlString = url ?? defaultUrl;

  return (
    <div
      className="logo"
      style={{
        float,
        display: display ?? "inline-block",
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}

export function BunnyLogo(props: LogoProps) {
  const { url, float, display, height, width, margin } = props;
  const basePath = getBasePath();

  const defaultUrl = `${basePath}assets/clipboard-symbol-yellow.png`;
  const urlString = url ?? defaultUrl;

  return (
    <div
      className="logo"
      style={{
        float,
        display,
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}
